function capitalizeWord(word) {
  if (!word || typeof word !== 'string') return '';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export default capitalizeWord;
